import {
	MimaText,
	MimaDropdown,
	MimaInput,
	MimaButton,
} from '../../components';
import { billStore } from '../../stores';
import { Formik } from 'formik';
import React, { useMemo, useState } from 'react';

import { EnterPinContainer } from '../../containers';
import { useGetAirtimeDataVendors, useGetDataPlanByNetworkId } from '../../controllers/BillController';

function DataOne({
	bill,
	closeModal,
	pinContent,
	validationSchema,
	onSubmit,
	plans,
	needFeedback,
	setShowSurvey,
}) {
	const [networkId, setNetworkId] = useState("");

	const isCopied = Object.keys(bill).length > 0;

	const { networkVendors } = useGetAirtimeDataVendors();
	const { dataPlans, isLoading } = useGetDataPlanByNetworkId(networkId);


	const venList = useMemo(() => {
		const vendors = networkVendors.map(network => {
			return { id: network.id, value: network.carrier };
		});
		return vendors
	}, [networkVendors])

	const planData = plans(venList.find(x => (
		x.value === bill?.networkId
	))?.id)?.find(y => (
		y?.value?.includes(bill?.cableTvName)
	));

	const mappedDataPlan = dataPlans.map((x) => (
		{
			id: x._id,
			value: x.plan,
		}
	))

	return (
		<>
			{!pinContent && (
				<Formik
					initialValues={{
						phone: isCopied ? bill?.phone : '',
						dataId: isCopied ? planData?.id : '',
						plan: isCopied ? planData?.value : '',
						networkName: isCopied ? bill.networkId : "",
						networkId: isCopied ? venList.find(x => (
							x?.value === bill?.networkId
						))?.id : "",
					}}
					validationSchema={validationSchema}
					onSubmit={onSubmit}
				>
					{({
						handleChange,
						handleBlur,
						handleSubmit,
						setFieldValue,
						values,
						errors,
						touched,
					}) => (
						<>
							<MimaText variant="subtitle" mb={4} ml={15}>
								Data
							</MimaText>
							<MimaDropdown
								labelTitle="Select Network"
								placeholder="-Select-"
								id="networkName"
								name="networkName"
								value={values.networkName}
								data={venList}
								onChange={data => {
									setFieldValue('networkId', data.id);
									setFieldValue('networkName', data.value);
									setNetworkId(data.id)
								}}
								error={errors.networkName}
								touched={touched.networkName}
							/>
							<MimaInput
								type="text"
								labelTitle="Phone Number"
								placeholder="Phone number"
								name="phone"
								mb={2}
								value={values.phone}
								onChange={handleChange}
								onBlur={handleBlur}
								error={errors.phone}
								touched={touched.phone}
							/>

							<MimaDropdown
								labelTitle="Select Plan"
								placeholder="-Select-"
								id="plan"
								name="plan"
								value={values.plan}
								data={mappedDataPlan}
								onChange={data => {
									setFieldValue('dataId', data.id);
									setFieldValue('plan', data.value);
								}}
								error={errors.plan}
								touched={touched.plan}
								loading={isLoading}
							/>
							<MimaButton
								title="Continue"
								onClick={handleSubmit}
								type="submit"
								mt={2}
							/>
						</>
					)}
				</Formik>
			)}

			{pinContent && <EnterPinContainer closeModal={closeModal} needFeedback={needFeedback} setShowSurvey={setShowSurvey} />}
		</>
	);
}

export default DataOne;
